// The practice log on the server (/api/v3/core/practice/): time practised,
// the songs being learnt, and chord-change scores. For logged-in users.

import { getCookie } from '../../utils';

const BASE = '/api/v3/core/practice/';

// Today where the player is, which is the day their streak counts.
export function localDate(date = new Date()) {
    const pad = n => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function request(path, { method = 'GET', body, keepalive = false } = {}) {
    return fetch(`${BASE}${path}`, {
        method,
        credentials: 'same-origin',
        keepalive,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('guitarpartycsrftoken'),
        },
        body: body ? JSON.stringify(body) : undefined,
    }).then(response => {
        if (!response.ok) throw new Error(`${response.status} ${path}`);
        return response.json();
    });
}

export const fetchSummary = songId =>
    request(`summary/?song=${encodeURIComponent(songId || '')}&date=${localDate()}`);

// keepalive lets the last few seconds through as the page closes.
export const logTime = (songId, seconds, { keepalive = false } = {}) =>
    request('log/', { method: 'POST', body: { song: songId, seconds, date: localDate() }, keepalive });

// status: 'learning', 'learned' or null to take the song off the list.
export const setLearning = (songId, status) =>
    request('learning/', { method: 'POST', body: { song: songId, status, date: localDate() } });

export const fetchChangeScores = (keys, instrumentId) =>
    request(`changes/?pairs=${encodeURIComponent(keys.join(','))}&instrument=${encodeURIComponent(instrumentId || '')}`);

export const saveChangeScore = ({ a, b, changes, seconds, songId, instrumentId }) =>
    request('changes/', { method: 'POST', body: { first: a, second: b, changes, seconds, song: songId, instrument: instrumentId } });
